export default "__VITE_ASSET__5v94FO9Z__"